import config from '@/config'
import getComponentsApplyInfo, { locationInfo } from '@/componentsApplyInfo'
import store from '@/store'
import { themeOptions } from '@/style/primary'

import utils from '@/utils'

// 获取 url 中 year 和 location 的值
// 把 url 中明显不符合规则的值重定向到默认年份||地方
const { year, location } = utils.getUrlParam(config.defaultCon, locationInfo)

const locationCN = config.adapter[location].cn

let componentsApplyInfo = getComponentsApplyInfo(year, location)

utils.setKeyInfoToStore({
  year,
  location,
  locationCN,
  themeOptions,
  store,
  defaultCon: config.defaultCon,
  componentsApplyInfo })

export { year, location }
